import {
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
} from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import SearchField from "../../../../components/SearchField/SearchField";
import {
  SearchResult,
  SearchSchoolDistrictContainerProps,
} from "../../../../types/types";
import { useLazySearchCategoryQuery } from "../../api/categoryApiSlice";
import { Category } from "../../types/types";

const SearchCategoryContainer: React.FC<
SearchSchoolDistrictContainerProps<Category>
> = ({ onChangeState, filterId }) => {
  const [options, setOptions] = useState<SearchResult[]>([])

  const [searchCategory, { isLoading,}] =
    useLazySearchCategoryQuery();

  const onFetch = async (
    event: SyntheticEvent<Element, Event>,
    value: string,
    reason: AutocompleteInputChangeReason
  ) => {
    try {
      const newOptions = await searchCategory({
        projectId: filterId!,
        term: value
      }).unwrap()

      setOptions(newOptions);
    } catch (error) {
      console.error(error)
    }
  };

  const onChagneHandler = (
    event: SyntheticEvent<Element, Event>,
    value: SearchResult | null,
    reason: AutocompleteChangeReason
  ) => {
    if (value?.id) {
      onChangeState({ _id: value.id, title: value.label })
    }
  }

  return (
    <SearchField
      options={options}
      loading={isLoading}
      handleInputChange={onFetch}
      onChangeHandle={onChagneHandler}
    />
  )
}

export default SearchCategoryContainer
